import { render } from "./BaseDuration.vue?vue&type=template&id=97b4709a"
import script from "./BaseDuration.vue?vue&type=script&lang=js"
export * from "./BaseDuration.vue?vue&type=script&lang=js"

import exportComponent from "/opt/microsoft-academy/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__